import React, { Component } from 'react'
import { Link } from 'react-router-dom'


class HomeContainer extends Component {
  render() {
    return (
      <div>
        <h2>Home Container</h2>
        <p><Link to='/'>Landing</Link></p>
        <p><Link to='/signin'>Sign In</Link></p>
      </div>
    )
  }
}

export default HomeContainer


// WEBPACK FOOTER //
// ./src/containers/HomeContainer.js